module.exports = __webpack_public_path__ + "f5dc02fc0cdb4fc3305a171a4026f68e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sv.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sv.svg
// module chunks = 0